import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const FeatureCard = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
  borderRadius: "8px",
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.grey[200]}`,
}));

const DevWarnings = () => {
  const [showModel, setShowModel] = useState(true);

  return (
    <Dialog
      aria-labelledby="letter-warnings"
      open={showModel}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="text-dark pb-2">
        <Typography
          variant="overline"
          className="text-truncate"
          display="block"
          style={{ maxWidth: "90%" }}
        >
          <strong className="text-danger mr-2">Warnings:</strong>
          Testing Environment
        </Typography>
      </DialogTitle>

      <DialogContent className="py-1">
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
        ></Typography>
        <div className="alert alert-warning" role="alert">
          <h4 class="alert-heading">Testing Environment!</h4>
          <p>
            You are currently accessing the <strong>testing environment</strong>{" "}
            of IPPIS.
          </p>
        </div>

        <FeatureCard>
          <CheckCircleOutlineIcon color="warning" />
          <Box>
            <Typography variant="subtitle2" fontWeight="600" gutterBottom>
              What to expect here:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Test features before they go live
              <br />
              • Practice workflows without consequences
              <br />
              • Data resets periodically
              <br />• Simulated environment only
            </Typography>
          </Box>
        </FeatureCard>
        <div className="alert alert-warning" role="alert">
          <strong>Important:</strong> Any changes made here will not affect live
          production data. This environment is for testing purposes only.
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center space-x-4 py-4">
        <Button
          variant="text"
          onClick={() => setShowModel(false)}
          className="mr-4"
        >
          Continue Testing
        </Button>
        <Button variant="contained" href="https://www.selfservice.ippis.rw">
          Go to Live Site
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DevWarnings;
